import { StepType, useTour } from '@reactour/tour';
import Content from 'ui/components/common/Tour/Content';
import { TOUR_SELECTOR } from 'ui/partials/Tour';

const useGetHowToQuickCreateTaskSteps = () => {
  const { setIsOpen, setSteps, setCurrentStep } = useTour();

  const quickCreateTaskSteps: StepType[] = [
    {
      content:
        'Click on the + Create button at the upper left corner of your screen.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.GENERAL_CREATE.CREATE}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(1), 200);
          },
          false,
        );
      },
      styles: {
        popover: (base) => ({ ...base, marginTop: 29 }),
      },
    },
    {
      content: 'Click the Create Task option.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.GENERAL_CREATE.TASK}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setTimeout(() => setCurrentStep(2), 200);
          },
          false,
        );
      },
      styles: {
        popover: (base) => ({ ...base, marginTop: 23 }),
      },
    },
    {
      content: (props) => (
        <Content
          {...props}
          // eslint-disable-next-line max-len
          content="Enter the task details, including the title, due date, task type, priority level, associated contact, and task assignment to a specific team member."
          type="create task"
        />
      ),
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.TASK.FORM.GENERAL.FORM}"]`,
      highlightedSelectors: [
        '[data-tut="global_create_panel_header"]',
        `[data-tut="${TOUR_SELECTOR.TOUR.SALES.TASK.FORM.GENERAL.FORM}"]`,
      ],
      position: 'left',
      stepInteraction: false,
      styles: {
        popover: (base) => ({ ...base, marginRight: 10 }),
      },
    },
    {
      content: 'Click create task, and you are done.',
      selector: `[data-tut="${TOUR_SELECTOR.TOUR.SALES.TASK.FORM.GENERAL.SAVE_BUTTON}"]`,
      action: (node: any) => {
        node?.addEventListener(
          'click',
          function () {
            setCurrentStep(0);
            setSteps?.([]);
          },
          false,
        );
      },
      position: 'top',
      styles: {
        popover: (base) => ({ ...base, top: -8 }),
      },
    },
  ];

  const showQuickCreateTaskSteps = () => {
    setTimeout(() => {
      setSteps?.(quickCreateTaskSteps);
      setIsOpen(true);
    }, 300);
  };

  return showQuickCreateTaskSteps;
};

export default useGetHowToQuickCreateTaskSteps;
